/**
 * Chat Manager Service
 * API calls for Chat Manager admin dashboard
 */
import axios from 'axios';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:8082';

class ChatManagerService {
    /**
     * Get server status (IP, RAM, CPU, Disk)
     */
    getServerStatus() {
        return axios.get(`${SOCKET_URL}/api/admin/server-status`, { withCredentials: true })
            .then(response => response.data);
    }

    /**
     * Get media stats grouped by date
     */
    getMediaStats() {
        return axios.get(`${SOCKET_URL}/api/admin/media/stats`, { withCredentials: true })
            .then(response => response.data);
    }

    /**
     * Get files for a specific date
     * @param {string} date - YYYY-MM-DD format
     */
    getMediaByDate(date) {
        return axios.get(`${SOCKET_URL}/api/admin/media/files/${date}`, { withCredentials: true })
            .then(response => response.data);
    }

    /**
     * Delete files by dates
     * @param {string[]} dates - Array of dates to delete
     */
    deleteMediaByDates(dates) {
        return axios.post(`${SOCKET_URL}/api/admin/media/delete`, { dates }, { withCredentials: true })
            .then(response => response.data);
    }

    /**
     * Get auto-delete settings
     */
    getSettings() {
        return axios.get(`${SOCKET_URL}/api/admin/media/settings`, { withCredentials: true })
            .then(response => response.data);
    }

    /**
     * Update auto-delete settings
     * @param {Object} autoDelete - { enabled: boolean, days: number }
     */
    updateSettings(autoDelete) {
        return axios.put(`${SOCKET_URL}/api/admin/media/settings`, { autoDelete }, { withCredentials: true })
            .then(response => response.data);
    }

    /**
     * Get media URL from socket server
     * @param {string} path - Relative path like /uploads/chat/filename.jpg
     */
    getMediaUrl(path) {
        if (!path) return '';
        if (path.startsWith('http')) return path;
        return `${SOCKET_URL}${path}`;
    }
}

export default new ChatManagerService();
